_ = require 'lodash'

module.exports =
class Slider

  ###
  @private
  @property [Object] default options
  ###
  defOpts =
    slickOpts:
      dots    : true
      arrows  : true
      infinite: true
      speed   : 500
      swipe   : false

  ###
  create Slider instance
  @param el [String|HTMLElement] element
  @param opts [Object] options
  ###
  constructor: (el, opts = {}) ->
    { slickOpts } = _.defaultsDeep opts, defOpts

    $ el
      .slick slickOpts



/** WEBPACK FOOTER **
 ** ./webpack/requires/pc/ui/slider.coffee
 **/